"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import Table from "../../../../components/Table";
import Button from "../../../../components/Button";
import Pagination from "../../../../components/Pagination";
import FilterSearch from "../../../../components/FilterSearch(name)";
import styles from "../css/medicalHistory.module.css";
import { fetchPatients } from "../../../../api/dispensary/script/processScriptApi";

export default function MedicalHistoryTableView() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [patients, setPatients] = useState([]);
  const rowsPerPage = 5; // Adjust number of rows per page

  // Load patients (mainmember list) from API on mount
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const data = await fetchPatients("");
        if (active) setPatients(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load patients", e);
        if (active) setPatients([]);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  // Filter data based on search term
  const filteredData = patients.filter(
    (row) =>
      row.surname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.initial.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.address.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate paginated data
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const columns = [
    { header: "Surname", accessor: "surname" },
    { header: "Initial", accessor: "initial" },
    { header: "Title", accessor: "title" },
    { header: "Address", accessor: "address" },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        <div className={styles.actionsRow}>
          <Button onClick={() => handleView(row)} variant="primary">View</Button>
        </div>
      ),
    },
  ];

  // Handlers
  const handleView = (row) => {
    navigate("/medical-history/medical-history-details", {
      state: {
        profileNo: row.profilenumber,
        patientLabel: `${row.surname} ${row.initial}. (${row.title || "Mr/Ms"})`,
      },
    });
    console.log("View patient profile:", row);
  };

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar />

        <main className={styles.content}>
          <div className={styles.searchBarWrapper}>
            <FilterSearch
              filterName="Filter"
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Search by surname, initial, title, or address..."
            />
          </div>

          <Table columns={columns} data={paginatedData} />

          {/* Pagination */}
          {totalPages > 1 && (
            <div className={styles.paginationWrapper}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          )}
        </main>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  );
}